export default {
    "title": "",
    "status": "draft",
    "author": null,
    "description": "",
    "categories": [],
    "prep_time": null,
    "cook_time": null,
    "serves": null,
    "minimum_serving": null,
    "maximum_serving": null,
    "storage": [],
    "related_recipes": [],
    "resource": "",
    "internal_notes": "",
    "video": "",
    "featured_image_portrait": "",
    "featured_image_landscape": "",
    "dietary_preferences": [],
    "protein": [],
    "nutritional_benefits": [],
    "secondary_health_benefits": [],
    "relevant": [],
    "recipe_type": [],
    "ingredient_groups": [],
    "instruction_groups": [],
    "meal_times": [],
    "effects": [],
    "intentions": [],
    "goals": [],
    "skill_levels": null,
}